import { Fragment } from "react"

import { Heading, Seo } from "@trueskin-web/components"

import UploadPhotos from "./upload-photos"

const DocumentsUpload = () => {
  return (
    <Fragment>
      <Seo title="Upload der Diagnose" />
      <Heading
        as="h1"
        mt={5}
        sx={{
          textAlign: "center",
          fontWeight: "bold",
          lineHeight: "smallerHeading",
        }}
      >
        Upload der Diagnose
      </Heading>

      <div sx={{ mt: 2, textAlign: "center" }}>
        Bitte laden Sie eine Kopie der von Ihrem Arzt gestellten Diagnose hoch.
      </div>

      <UploadPhotos />
    </Fragment>
  )
}

export default DocumentsUpload
